// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aDJdc","type":"styles_type__j8RpU","choices":"styles_choices__2XGBu"};